export default "__VITE_ASSET__4mJXFizl__"